<template>
<div class="cance-warp" :style="{'height': clientHeight}" 
           v-if="cancelData.showCancel" @touchmove="stopPierce">
            <div class="cancel-main" style="padding-bottom: 10rpx;">
                <div class="cancel-title">选择取消原因</div>
                <div id="scrollBox" scroll-y style="height: 400rpx;">
                    <div class="radio-group">
                        <label class="radio" v-for="(item,index) in cancelData.cancelReason" :key="index">
                            {{item.Reason}}
                            <input type="radio" class="cancel-radio" v-model="radioSelect" :value="item"/>
                            <div class="radio-img" :class="radioSelect && item.Id == radioSelect.Id ? 'active':'default'" ></div>
                        </label>
                    </div>
                </div>
                <div class="cancel-btn">
                    <div style="color: #333; border-right: 1px solid #ccc;" @click="cancelWrong">点错了</div>
                    <div :style="{'color': radioSelect ? '#18b861' : '#999'}" @click="cancelSubmit">取消订单</div>
                </div>
            </div>
</div> 
</template>
<script>
  import Bus from './bus.js'
     export default {
        props:[],
        data(){
            return {
                 mainList:true,
                 radioSelect:null,
                 cancelData: {
                    showCancel: false,
                    couldCancel: false,
                    cancelReason: [],
                    reason: {}
                },
                 clientHeight: document.documentElement.clientHeight + 'px',
            }
        },
        mounted() {
            let me = this;
             Bus.$on('showCanceldialog', (dialog) => {
                me.cancelData = dialog;
                me.cancelData.showCancel = true;
            })
            Bus.$on('hideCanceldialog', () => {
                me.cancelData.showCancel = false;
            })
            
        },
        methods:{
            cancelWrong(){
                this.cancelData.showCancel = false;
            },
            stopPierce(e) {
                e.stopPropagation();
                return false
            },
            cancelSubmit(){
                if(this.radioSelect){
                    this.cancelData.showCancel = false;
                    if(typeof this.cancelData.CallBack == 'function'){
                        this.cancelData.CallBack(this.radioSelect)
                    }
                }
            }
        }

    }
</script>
<style scoped lang="sass">
    .cance-warp
        position: fixed
        z-index: 1000
        top: 0
        left: 0
        width: 100%
        background: rgba(0, 0, 0, 0.4)
  
    .cancel-main 
        background: #fff
        width: 85%
        position: absolute
        top: 50%
        left: 50%
        -webkit-transform: translate3d(-50%, -50%, 0)
        transform: translate3d(-50%, -50%, 0)
        box-sizing: border-box
        border-radius: 4px
        z-index: 1001
    .cancel-title
        font-size: 0.32rem
        color: #333
        font-weight: bold
        text-align: center
        padding: 25px 0
    #scrollBox
        max-height: 200px
        overflow-y: scroll
    .radio-group 
        padding: 0 0.6rem
    .radio-group 
        label
            display: flex
            -webkit-justify-content: space-between
            -webkit-align-items: center
            font-size: 0.28rem
            color: #333
            margin-bottom: 20px
            line-height: 0
    .cancel-radio
        opacity: 0
    .radio-img.default
        width: 0.5rem
        height: 0.4rem
        background: url(../images/checkbox_default.png) no-repeat
        background-size: 0.3rem
        background-position: center
    .radio-img.active
        width: 0.5rem
        height: 0.4rem
        background: url(../images/checkbox_ed.png) no-repeat
        background-size: 0.3rem
        background-position: center
    .cancel-btn
        display: -webkit-flex
        border-top: 1px #ccc solid
        height: 50px
    .cancel-btn div
        flex: 1
        display: -webkit-flex
        -webkit-align-items: center
        -webkit-justify-content: center
        font-size: 0.32rem
</style>


// WEBPACK FOOTER //
// src/components/cancel.vue